





















































import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { Funcionalidades } from '@/config/funcionalidades';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { AxiosVue } from '@/AxiosVue';
import MantenedorGridTodos from '@/reusable/Grid/MantenedorGridTodos.vue';
import InfoCumplimientos from '@/pantallas/CertificadorBHP/InfoCumplimientos.vue';
import CorregirCumplimientos from '@/pantallas/CertificadorBHP/CorregirCumplimientos.vue';
import VerDetalleCertificado from '@/pantallas/CertificadorBHP/VerDetalleCertificado.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { actionsEvent } from '@/setup';
import { ServicioProxy, Accion } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';

@Component({
  components: {
    MantenedorGridTodos,
    FormFieldsContainer,
    InfoCumplimientos,
    CorregirCumplimientos,
    VerDetalleCertificado,
  },
})
export default class CertificadorBHP extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.CertificadorBHP;
  serie: string = '';
  gridApi: GridApi;
  serverSide: any;
  mostrarModalEditar: boolean = false;
  mostrarModalDetalle: boolean = false;
  rowData: any[] = [];
  ModalCumpliento: boolean = false;
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  columnApi: ColumnApi;
  searchPatente: string = '';
  filteredData: any[] = [];
  enrichedGridOptions: GridOptions = null;
  readonly gridOptions: GridOptions;
  selectedRowData: any = null;
  readonly loadingService = new LoadingService();
  Editar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.Editar, this.accionDetalle];

  mounted() {
    this.loadingService.showLoading(); // Mostrar la ventana de carga inmediatamente
    this.initializeGrid();
    setInterval(() => {
      if (!this.isAnyModalOpen()) {
        this.loadingService.showLoading(); // Mostrar ventana de carga antes de actualizar
        this.initializeGrid();
      }
    }, 5 * 60 * 1000);
  }
  isAnyModalOpen() {
    return (
      this.mostrarModalEditar ||
      this.mostrarModalDetalle ||
      this.ModalCumpliento
    );
  }
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onVerDetalle(this.handleVerDetalle);

    this.gridOptions = {
      onGridReady: this.onGridReady,
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 50,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      rowModelType: 'clientSide',
      domLayout: 'normal',
      columnDefs: [
        {
          headerName: 'Integrador',
          field: 'integrador',
        },
        {
          headerName: 'Patente',
          field: 'patente_vehiculo',
        },
        {
          headerName: 'Transportista',
          field: 'nom_transportista',
        },
        {
          headerName: 'Flota',
          field: 'flota',
        },
        {
          headerName: 'GPS',
          field: 'estado_desfase',
          cellRenderer: this.gpsCellRenderer,
        },
        {
          headerName: 'Fecha Actividad',
          field: 'fecha_actividad',
        },
        {
          headerName: 'Fecha Último Envío',
          field: 'fecha_ultimo_envio',
        },
        {
          headerName: 'Min Despacho',
          field: 'diferencia_minutos',
          cellRenderer: this.minDespachoCellRenderer,
        },
        {
          headerName: 'GPS cada 3 segundos',
          field: 'estado_frecuencia',
          cellRenderer: this.gpsCellRenderer,
        },
        {
          headerName: '% Cumplimiento Real',
          field: 'promedio',
          cellRenderer: this.porcentajeCellRenderer,
        },
        {
          headerName: '% Cumplimiento Certificación',
          field: 'promedio2',
          cellRenderer: this.porcentajeCellRenderer,
        },
        {
          headerName: 'Acelerómetro',
          field: 'estado_acelerometro',
          cellRenderer: this.gpsCellRenderer,
        },
        {
          headerName: 'Identificación Conductor',
          field: 'estado_conductor',
          cellRenderer: this.gpsCellRenderer,
        },
        {
          headerName: 'AVL',
          field: 'avl',
        },
      ],
    };
  }

  gpsCellRenderer(params: ICellRendererParams) {
    const color = params.value === 'CUMPLE' ? 'green' : 'red';
    const span = document.createElement('span');
    span.style.display = 'flex';
    span.style.alignItems = 'center';
    span.innerHTML = `
      <span style="width: 10px; height: 10px; background-color: ${color}; border-radius: 50%; margin-right: 5px;"></span>
      ${params.value}
    `;

    span.dataset.value = params.value;

    return span;
  }

  filtrarPorPatente() {
    if (this.gridApi) {
      const filterValue = this.searchPatente.toLowerCase();
      console.log('Valor de búsqueda:', filterValue);
      this.gridApi.setQuickFilter(filterValue);
    }
  }

  limpiarFiltro() {
    this.searchPatente = '';
    this.gridApi.setQuickFilter('');
    console.log('Filtro limpiado');
  }

  refreshGridData() {
    if (this.gridApi) {
      this.gridApi.purgeServerSideCache();
    }
  }

  async onGridReady(params: GridReadyEvent) {
    this.loadingService.showLoading();
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    console.log('Grid está listo');
    // Llama a initializeGrid solo cuando gridApi esté definido
    if (this.gridApi) {
      this.initializeGrid();
    } else {
      console.error('gridApi no está disponible en onGridReady');
    }
  }

  initializeGrid() {
    const self = this;
    self.loadingService.showLoading(); // Mostrar la ventana de carga inmediatamente

    self.axios.http
      .post('Metabase/PostgenericA/certificador_bhp/getVehiculosBhp')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          self.rowData = response.data.data;
          self.gridApi.setRowData(response.data.data);
          self.filteredData = self.rowData;
          self.gridApi.hideOverlay();
          self.loadingService.hideLoading(); // Ocultar la ventana de carga solo si los datos son correctos
        } else {
          self.gridApi.setRowData([]);
          self.gridApi.showNoRowsOverlay();
        }
      })
      .catch((error: any) => {
        self.rowData = [];
        self.gridApi.setRowData([]);
        self.gridApi.showNoRowsOverlay();
      })
      .finally(() => {
        if (self.rowData.length === 0) {
          self.loadingService.hideLoading();
        }
        self.gridApi.setDomLayout('autoHeight');
      });
  }

  async handleCierreModal() {
    this.ModalCumpliento = false;
    this.mostrarModalEditar = false;
    this.mostrarModalDetalle = false;
    this.loadingService.hideLoading();
  }
  minDespachoCellRenderer(params: ICellRendererParams) {
    return `${params.value} min`;
  }

  porcentajeCellRenderer(params: ICellRendererParams) {
    return `${params.value} %`;
  }

  async handleEditarClick(params: any) {
    this.mostrarModalEditar = true;
    this.selectedRowData = params.data;
  }

  async handleVerDetalle(params: any) {
    this.loadingService.showLoading();
    this.mostrarModalDetalle = true;
    this.selectedRowData = params.data;
    setTimeout(() => {
      this.loadingService.hideLoading();
    }, 1000);
  }

  handleModalClick() {
    this.ModalCumpliento = true;
  }
}
